<div class="investment-instruction-card">
  <div class="dot" [style.background-color]="instruction?.fund | investmentInstructionFundColour"></div>
  <span class="label-md mb-2">{{ instruction?.fund?.name }}</span>
  <span class="mt-auto">{{ instruction?.percentage | number : '1.2-2' }}%</span>
</div>
